import $ from 'jquery';
import Datepicker from 'vanillajs-datepicker/js/Datepicker';
import fr from 'vanillajs-datepicker/js/i18n/locales/fr';

Object.assign(Datepicker.locales, fr);

import { $Elements, Classes, Elements, Events } from '../global/constants';
import { ajax, disableBodyScroll, enableBodyScroll } from '../global/helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Flag and prefix Phone -------

	const selector = document.getElementById('countrySelector');
	const list = document.getElementById('countriesList');
	const search = document.getElementById('countrySearch');

	if(selector && list) {

		const flagImg = selector.querySelector('.flag');
		const prefixInput =document.getElementById('code');
		const items = list.querySelectorAll('.countries-item');

		selector.addEventListener('click', (e) => {
			e.stopPropagation();
			list.style.display = list.style.display === 'block' ? 'none' : 'block';
			search.value = '';
			filterCountries('');
			search.focus();
		});

		document.addEventListener('click', () => {
			list.style.display = 'none';
		});

		search.addEventListener('input', () => {
			const term = search.value.trim().toLowerCase();
			filterCountries(term);
		});

		function sanitizeName(name){
			return name.normalize("NFD").replace(/[\u0300-\u036f]/g, '').toLowerCase();
		}

		function filterCountries(term) {
			const cleanTerme = sanitizeName(term);

			items.forEach(item => {
				const name = item.dataset.name;
				const clearName = sanitizeName(name);
				item.style.display = clearName.includes(cleanTerme) ? 'flex' : 'none';
			});
		}

		items.forEach(item => {
			item.addEventListener('click', () => {
				const newFlag = item.dataset.flag;
				const newPrefix = item.dataset.prefix;

				flagImg.src = newFlag;
				flagImg.alt = item.dataset.name;
				prefixInput.value = newPrefix;
				prefixInput.dispatchEvent(new Event('input', { bubbles: true }));
				list.style.display = 'none';
			});
		});
	}

	// ---------- Handle Form ----------

	function handleForm(form, params) {

		const formContent = form.find('.form-content');
		const formDone = form.find('.form-done');
		const formSuccess = formDone.find('.success');
		const formError = formDone.find('.error');
		const formButton = form.find('button[type=submit]');
		const date = form.get(0).querySelector('[name=date]');

		if(date) {

			const picker = new Datepicker(date, {
				buttonClass: 'btn',
				autohide: true,
				language: document.documentElement.attributes.lang.value || 'fr',
			});
		}

		form.on('submit', e => e.preventDefault());

		form.parsley().on('form:submit', async function() {

			Elements.LoadingBar.classList.add(Classes.loading);
			formButton.attr('disabled', true);

			const formData = new FormData(form[0]);
			formData.append('action', params.action);
			formData.append('nonce', params.nonce);

			try {

				const response = await ajax({
					url: params.url,
					type: 'POST',
					dataType: 'json',
					data: formData,
					processData: false,
					contentType: false,
				});

				formSuccess.removeClass(Classes.hidden);
			}
			catch(e) {
				formError.removeClass(Classes.hidden);
			}

			Elements.LoadingBar.classList.remove(Classes.loading);
			formButton.attr('disabled', false);
			formContent.addClass(Classes.hidden);
			formDone.removeClass(Classes.hidden);

			return false;
		});
	}

	// ---------- Contact Form ----------

	if(typeof contact_form_params !== 'undefined') {

		$('form.contact-form').each(function() {
			handleForm($(this), contact_form_params);
		});
	}

	// ---------- Visit Form ----------

	if(typeof visit_form_params !== 'undefined') {

		$('#visit-modal').on('show.bs.modal', function(e) {
			const self = $(this);

			self.find('.form-content').removeClass('d-none');
			self.find('.form-done, .form-done .success, .form-done .error').addClass(Classes.hidden);

			disableBodyScroll();
		});

		$('#visit-modal').on('hidden.bs.modal', function(e) {
			enableBodyScroll();
		});

		$('form.visit-form').each(function() {
			handleForm($(this), visit_form_params);
		});
	}

});
